import axios from "axios";
import { endpoints } from "../utils/endpoints";

export const getBatteryMovements = async ({ queryKey }) => {
  const [, { limit, page }, filters] = queryKey;

  const queryParams = new URLSearchParams();

  if (filters.batteryId) queryParams.append("batteryId", filters.batteryId);
  if (filters.status) queryParams.append("status", filters.status);
  if (filters.initiatedBy)
    queryParams.append("initiatedBy", filters.initiatedBy);

  if (filters.fromState) queryParams.append("fromState", filters.fromState);
  if (filters.toState) queryParams.append("toState", filters.toState);

  const startDate = filters.dateRange?.startDate;
  const endDate = filters.dateRange?.endDate;

  if (startDate)
    queryParams.append("startDate", new Date(startDate).toISOString());
  if (endDate) queryParams.append("endDate", new Date(endDate).toISOString());

  queryParams.append("limit", limit);
  queryParams.append("offset", (page - 1) * limit);

  const { data } = await axios.get(
    `${endpoints.battery.getBatteryMovements}?${queryParams.toString()}`
  );
  return data;
};
